<template>
  <div>
    <div class="due-row" v-for="(item, index) in course_payments" :key="index">
      <div
        class="due-list"
        v-if="item.outstanding_amount > 0"
        v-bind:class="checkOverdue(item.due_date)"
      >
        <h3>
          Installment {{ item.installment_no
          }}<span
            >{{ currency.symbol }} {{ numberWithCommas(item.outstanding_amount)
            }}<sup>{{ currency.code }}</sup></span
          >
        </h3>
        <b
          >Over Due on {{ item.due_on
          }}<span v-if="item.due_days">{{ item.due_days }} Days</span></b
        >
        <div class="btn-area">
          <button
            v-if="payOnline"
            type="button"
            @click="
              recieptPay(item.id, item.course_id, item.outstanding_amount)
            "
            class="btn btn-secondary"
            data-toggle="modal"
            data-target="#online-pay-modal"
          >
            Pay Online
          </button>
          <button
            type="button"
            @click="
              recieptPay(item.id, item.course_id, item.outstanding_amount)
            "
            class="btn btn-secondary"
            data-toggle="modal"
            data-target="#bank-pay-modal"
          >
            Bank Payment
          </button>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="bank-pay-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Bank payment</h5>
            <img
              class="close"
              src="/media/icons/close.png"
              data-dismiss="modal"
              aria-label="Close"
              width="53px"
            />
          </div>
          <div class="modal-body">
            <div
              class="alert alert-success"
              id="submit_success"
              style="display: none"
            >
              Payment Successful
            </div>
            <div
              class="alert alert-danger"
              id="submit_error"
              style="display: none"
            >
              Payment Error
            </div>
            <form id="payment-data">
              <div class="form-group">
                <label>* Payment Amount ({{ currency.code }})</label>
                <input
                  type="number"
                  class="form-control"
                  :max="amount"
                  id="amount"
                  name="amount"
                  v-model="amount"
                  aria-describedby="emailHelp"
                  :placeholder="
                    'Enter Payment Amount (' + currency.symbol + ')'
                  "
                />
              </div>

              <span id="amount_error" style="display: none" class="text-danger"
                >This field is required</span
              >
              <div class="form-group">
                <label>* Payment Date</label>
                <datetime
                  v-model="date"
                  format="yyyy-MM-dd"
                  placeholder="YYYY-MM-DD"
                  input-class="form-control"
                >
                </datetime>
                <!-- <input type="date" class="form-control" id="date" name="date" v-model="date" placeholder="Enter Payment date"> -->
                <span id="date_error" style="display: none" class="text-danger"
                  >This field is required</span
                >
              </div>
              <div class="form-group">
                <label>* Receipt No</label>
                <input
                  type="text"
                  class="form-control"
                  id="receipt_no"
                  v-model="receipt_no"
                  name="receipt_no"
                  placeholder="Enter Receipt No"
                />
                <span
                  id="receipt_no_error"
                  style="display: none"
                  class="text-danger"
                  >This field is required</span
                >
              </div>
              <div>
                <label>* Receipt Image</label>
                <input
                  type="file"
                  name="file"
                  id="file"
                  ref="file"
                  v-on:change="handleFileUpload()"
                />

                <div>
                  <span
                    id="file-error"
                    style="display: none"
                    class="text-danger"
                    >This field is required</span
                  >
                </div>
                <div class="file-message">
                  Max file size <span>2MB</span> Supported file formats:
                  <span>JPEG/PNG/PDF</span>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-primary"
              :disabled="is_submit"
              @click="formSubmit"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="online-pay-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <form id="payment-form">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">
                Online payment
              </h5>
              <img
                class="close"
                src="/media/icons/close.png"
                data-dismiss="modal"
                aria-label="Close"
                width="53px"
              />
            </div>
            <div class="modal-body">
              <h2>Payment Amount ({{ currency.code }}) {{ onlineamount }}</h2>
              <div id="card-element"></div>
              <div class="form-check-label" id="card-errors" role="alert"></div>
              <div class="form-group form-check">
                <input
                  type="checkbox"
                  v-model="checked"
                  class="form-check-input"
                  id="terms_check"
                />
                <label class="form-check-label" for="exampleCheck1"
                  >I have read and agreed with the terms and conditions</label
                >
              </div>
              <!-- <div
              class="alert alert-success"
              id="submitonline_success"
              style="display: none"
            >
              Please wait while we process your request....
            </div>
            <div
              class="alert alert-danger"
              id="submitonline_error"
              style="display: none"
            >
              Payment amount should not exceed the installment amount
            </div> -->
              <!-- <form id="payment-data">
              <div>
                <label>Payment Amount ({{ currency.code }})</label>
                <input
                  type="number"
                  class="form-control"
                  :max="amount"
                  id="amount"
                  name="online_amount"
                  v-model="onlineamount"
                  aria-describedby="emailHelp"
                  :placeholder="
                    'Enter Payment Amount (' + currency.symbol + ')'
                  "
                />
              </div>
              <span id="amount_error" style="display: none" class="text-danger"
                >This field is required</span
              >
              <br />
              <div class="form-group">
                <a href="/doc/Terms and Conditions.pdf" download
                  >Read terms and Conditions</a
                >
              </div>
              <div class="form-group form-check">
                <input
                  type="checkbox"
                  v-model="checked"
                  class="form-check-input"
                  id="terms_check"
                />
                <label class="form-check-label" for="exampleCheck1"
                  >I have read and agreed with the terms and conditions</label
                >
              </div>
            </form> -->
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" :disabled="!checked" id="submit">
                Proceed to pay
              </button>
            </div>
          </form>
          <input
            type="hidden"
            class="form-control"
            :max="amount"
            id="amount"
            name="online_amount"
            v-model="onlineamount"
            aria-describedby="emailHelp"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import Vue from "vue";
import moment from "moment";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
var $ = require("jquery");
var Cookies = require("vue-cookies");
var Config = require("../../router/Config");
Vue.use(require("vue-moment"));
Vue.component("datetime", Datetime);
// var userPermissions = Cookies.get('userPermissions')

export default {
  name: "payment",
  components: {},
  props: ["getCourse"],
  data() {
    this.publishableKey =
      "pk_test_51IxoHAASBApcquiHMc85vM2EyjBXvBtueTKr11luel7dBUVnyNZK1wxdeg4reI7kJhLwcznLmJRHEyaRzloH7cnb00X6uhwpiR";
    return {
      payOnline: Config.clientFeature ? Config.clientFeature.payOnline : false,
      course_payments: [],
      course_statics: [],
      user: [],
      amount: "",
      onlineamount: "",
      date: "",
      receipt_no: "",
      schedule_id: "",
      clientSecret: "",
      course_id: "",
      student_id: "",
      file: "",
      sessionId: "",
      modalShow: true,
      checked: false,
      is_submit: false,
      currency: [],
      elementsOptions: {
        appearance: {}, // appearance options
      },
      confirmParams: {
        return_url: "http://localhost:8080/subjects", // success url
      },
      token: null,
      result: null,
      stripeId:
        "sk_test_51IxoHAASBApcquiHiV3AwJlTIyxyLUJGWRggyi21U14J6qH0VXmbIIJDSVGrzcK3WllxgojE9rsa8hZLYVrtoEPT00IOFt8ffT",
    };
  },
  mounted() {
    // if (Cookies.get("company").stripe_connect_id !== null) {
    //   let self = this;
    //   let stripe = Stripe(this.publishableKey, {
    //     stripeAccount: Cookies.get("company").stripe_connect_id,
    //   });
    //   const appearance = {
    //     theme: "stripe",

    //     variables: {
    //       colorPrimary: "#0570de",
    //       colorBackground: "#ffffff",
    //       colorText: "#30313d",
    //       colorDanger: "#df1b41",
    //       fontFamily: "Ideal Sans, system-ui, sans-serif",
    //       spacingUnit: "2px",
    //       borderRadius: "4px",
    //       // See all possible variables below
    //     },
    //   };
    //   var elements = stripe.elements();
    //   var style = {
    //     base: {
    //       color: "#32325d",
    //     },
    //   };

    //   var card = elements.create("card", { style: style }, appearance);
    //   card.mount("#card-element");
    //   card.on("change", function (event) {
    //     var displayError = document.getElementById("card-errors");
    //     if (event.error) {
    //       displayError.textContent = event.error.message;
    //     } else {
    //       displayError.textContent = "";
    //     }
    //   });

    //   var form = document.getElementById("payment-form");
    //   form.addEventListener("submit", function (ev) {
    //     ev.preventDefault();
    //     self.checked = false;
    //     stripe
    //       .confirmCardPayment(self.clientSecret, {
    //         payment_method: {
    //           card: card,
    //           billing_details: {
    //             name: Cookies.get("student_number"),
    //           },
    //         },
    //       })
    //       .then(function (result) {
    //         if (result.error) {
    //           // Show error to your customer (for example, insufficient funds)
    //           self.checked = true;
    //           self.$notify({
    //             type: "error",
    //             title: "Payment",
    //             group: "foo",
    //             text: result.error.message,
    //           });
    //         } else {
    //           // The payment has been processed!
    //           if (result.paymentIntent.status === "succeeded") {
    //             // Show a success message to your customer
    //             self.$notify({
    //               type: "success",
    //               title: "Payment",
    //               group: "foo",
    //               text: "Payment done successfuly",
    //             });
    //             // There's a risk of the customer closing the window before callback
    //             // execution. Set up a webhook or plugin to listen for the
    //             // payment_intent.succeeded event that handles any business critical
    //             // post-payment actions.
    //             self.axios
    //               .post(
    //                 Config.API_URL +
    //                   "/api/fe/student/payment-success" +
    //                   "?token=" +
    //                   Cookies.get("accessToken"),
    //                 {
    //                   amount: self.onlineamount,
    //                   course_id: self.course_id,
    //                   student_id: Cookies.get("studentId"),
    //                   schedule_id: self.schedule_id,
    //                   payment_data: result.paymentIntent,
    //                 }
    //               )
    //               .then((response) => {
    //                 console.log(response);
    //                 self.getCourseStatics();
    //                 $("#submitonline_success")
    //                   .fadeTo(5000, 700)
    //                   .slideUp(500, function () {
    //                     $("#submitonline_success").slideUp(500);
    //                   });
    //                 setTimeout(function () {
    //                   $("#online-pay-modal").hide();
    //                 }, 4000);
    //               })
    //               .catch(function (error) {
    //                 console.log(error);
    //               });
    //           }
    //         }
    //       });
    //   });
    // }
    this.user = Cookies.get("userDetail");
    this.getCourseStatics();
    this.currency = Cookies.get("currency");
  },
  computed: {},
  // created () {
  //   this.interval = setInterval(() => this.getCourseStatics(), 10000)
  // },
  beforeDestroy: function () {},
  methods: {
    // submit: function () {
    //   // this will trigger the process
    //   //Get the stripe ID (PI secret key)
    //   this.$refs.elementRef.submit();
    // },
    // tokenCreated(token) {
    //   this.token = token;
    //   this.confirmPayment(token);
    // },
    // confirmPayment: function (token) {
    //   this.$stripe
    //     .confirmCardPayment(this.clientSecret, {
    //       payment_method: {
    //         card: {
    //           token: token.id,
    //         },
    //         billing_details: {
    //           name: "Jenny Rosen",
    //         },
    //       },
    //     })
    //     .then((result) => {
    //       this.result = result;
    //       if (result.paymentIntent.status === "succeeded") {
    //         //do something
    //       }
    //       console.log(result);
    //     });
    // },
    generatePaymentIntent: function (amount) {
      this.axios
        .post(
          Config.API_URL +
            "/api/fe/stripe/create-intent" +
            "?token=" +
            Cookies.get("accessToken"),
          {
            amount: amount,
          }
        )
        .then((response) => {
          if (response.data.res) {
            this.clientSecret = response.data.data;
          }
        });
    },
    getCourseStatics: function () {
      this.$emit("getCourse");
      this.axios
        .post(
          Config.API_URL +
            "/api/fe/course/statics/" +
            Cookies.get("userId") +
            "/" +
            Cookies.get("studentId") +
            "/" +
            Cookies.get("clientId") +
            "/" +
            Cookies.get("courseId") +
            "?token=" +
            Cookies.get("accessToken"),
          {
            is_bundle: Cookies.get("is_bundle"),
            bundle_course_id: Cookies.get("bundle_course_id"),
          }
        )
        .then((response) => {
          this.course_statics = response.data.data;
          this.course_payments = this.course_statics.payments_all;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    checkOverdue: function (date) {
      var CurrentDate = new Date();
      var DueDate = new Date(date);
      if (
        moment(moment(String(CurrentDate)).format("YYYY-MM-DD")).isSame(
          moment(String(DueDate)).format("YYYY-MM-DD")
        )
      ) {
        return "pay-success";
      }
      if (
        moment(moment(String(CurrentDate)).format("YYYY-MM-DD")).isBefore(
          moment(String(DueDate)).format("YYYY-MM-DD")
        )
      ) {
        return "pay-success";
      } else {
        return "pay-error";
      }
    },
    handleFileUpload: function () {
      this.file = this.$refs.file.files[0];
      console.log(this.file);
    },
    formSubmit: function () {
      $("#receipt_no_error").hide();
      $("#date_error").hide();
      $("#amount_error").hide();
      $("#file-error").hide();
      if (this.amount === "") {
        $("#amount_error").show();
        return false;
      }
      if (this.date === "") {
        $("#date_error").show();
        return false;
      }
      if (this.receipt_no === "") {
        $("#receipt_no_error").show();
        return false;
      }
      if (this.file === "") {
        $("#file-error").show();
        return false;
      }
      this.is_submit = true;
      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("amount", this.amount);
      formData.append("date", this.date);
      formData.append("ref_no", this.receipt_no);
      formData.append("course_id", this.course_id);
      formData.append("schedule_id", this.schedule_id);
      formData.append("student_id", this.user.student[0].id);
      formData.append("email", this.user.email);
      formData.append("name", this.user.first_name);
      this.axios
        .post(
          Config.API_URL +
            "/api/fe/student/receipt-payments" +
            "?token=" +
            Cookies.get("accessToken"),
          formData
        )
        .then((response) => {
          if (response.data.res === "1") {
            $("#submit_success").html(response.data.msg);
            $("#submit_success")
              .fadeTo(5000, 500)
              .slideUp(500, function () {
                $("#submit_success").slideUp(500);
              });
            this.reset();
            setTimeout(function () {
              $("#bank-pay-modal").hide();
            }, 1000);
          } else {
            $("#submit_error").html(response.data.msg);
            this.is_submit = false;
            $("#submit_error")
              .fadeTo(5000, 500)
              .slideUp(500, function () {
                $("#submit_error").slideUp(500);
              });
          }
        })
        .catch(function (error) {
          $("#submit_error").html(error);
          $("#submit_error")
            .fadeTo(5000, 500)
            .slideUp(500, function () {
              $("#submit_error").slideUp(500);
            });
        });
    },
    recieptPay: function (Payid, Courseid, Amount) {
      this.amount = Amount;
      this.onlineamount = Amount;
      this.course_id = Courseid;
      this.schedule_id = Payid;
      this.date = "";
      this.receipt_no = "";
      this.checked = false;
      this.generatePaymentIntent(Amount);
      $("#file").val("");
    },
    reset: function () {
      this.amount = "";
      this.onlineamount = "";
      this.file = "";
      this.course_id = "";
      this.schedule_id = "";
      this.date = "";
      this.receipt_no = "";
      this.getCourseStatics();
      this.is_submit = false;
      $("#file").val("");
    },
    pay: function () {
      var random = Math.floor(1000 + Math.random() * 9000);
      var orderid = this.schedule_id + "T" + random;
      var enteredAmount = $("input[name=online_amount]").val();
      if (parseFloat(enteredAmount) > this.amount) {
        $("#submitonline_error")
          .fadeTo(5000, 500)
          .slideUp(500, function () {
            $("#submitonline_error").slideUp(500);
          });
      } else {
        Cookies.set("installment_id", orderid);
        Cookies.set("course_id", this.course_id);
        var currentUrl = window.location.href;
        this.amount = enteredAmount;
        this.axios
          .post(
            Config.API_URL +
              "/api/fe/student/payment-seesionId" +
              "?token=" +
              Cookies.get("accessToken"),
            {
              order_id: orderid,
              returnURL: currentUrl,
              amount: this.amount,
              course_id: this.course_id,
            }
          )
          .then((response) => {
            console.log(response);
            this.sessionId = response.data.session.id;
            Cookies.set("successIndicator", response.data.successIndicator);
            window.Checkout.configure({
              session: {
                id: this.sessionId,
              },
              merchant: Config.IPG_MERCHANT_ID,
              interaction: {
                merchant: {
                  name: Cookies.get("firstName"),
                },
                operation: "PURCHASE",
                displayControl: {
                  billingAddress: "HIDE",
                  customerEmail: "HIDE",
                  orderSummary: "HIDE",
                  shipping: "HIDE",
                },
              },
            });
            $("#submitonline_success")
              .fadeTo(5000, 700)
              .slideUp(500, function () {
                $("#submitonline_success").slideUp(500);
              });
            setTimeout(function () {
              $("#online-pay-modal").hide();
            }, 4000);
            window.Checkout.showLightbox();
          })
          .catch(function (error) {
            console.log(error);
          });
      }
      // var payment = {
      //   sandbox: true, // if the account is sandbox or real
      //   merchant_id: Config.Merchant_id, // Replace your Merchant ID
      //   return_url: 'http://sample.com/return',
      //   cancel_url: 'http://sample.com/cancel',
      //   notify_url: Config.API_URL + '/api/fe/payments/notify',
      //   order_id: Payid,
      //   items: this.course_statics.name,
      //   amount: Amount,
      //   currency: 'LKR',
      //   first_name: this.user.first_name,
      //   last_name: this.user.last_name,
      //   email: this.user.email,
      //   phone: this.user.contact_number,
      //   address: this.user.student[0].adderess,
      //   city: 'Colombo',
      //   country: 'Sri Lanka',
      //   custom_1: this.user.student[0].id
      // }
      // window.payhere.startPayment(payment)
    },
  },
};
// window.payhere.onCompleted = function onCompleted (orderId) {
//   axios.post(Config.API_URL + '/api/fe/payments/notify', {
//     order_id: orderId
//   }).then(response => {
//     Vue.notify({
//       type: 'success',
//       group: 'foo',
//       title: 'Payment Success',
//       text: 'Your Payment has been completed.'
//     })
//   }).catch(function (error) {
//     Vue.notify({
//       type: 'error',
//       group: 'foo',
//       title: 'Payment Error',
//       text: error
//     })
//   })
// }
</script>

<style scoped lang="scss">
@import "../../assets/scss/component/subject/subject";
</style>
